import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'

const routeRecord: RouteRecordRaw = {
  name: 'client.messenger',
  path: 'messenger',
  component: () => import('src/client/pages/ClientMessenger.vue'),
  meta: {
    roles: [Roles.Client],
    supportedPlatforms: ['desktop', 'mobile', 'native'],
    excludeEnv: [],
  },
}

export default routeRecord
